







import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import createjs from 'createjs-npm';
import Game from '@/servers/modules/game/index'; // server
import { Howl, Howler } from 'howler';
import { Base, App } from '../common/base';
import { config } from './config.js';
import log from '../../../../servers/modules/vocabulary/log';

@Component({
  components: {},
})
export default class extends Vue {
  @Getter public getGameLoading: any;

  @Mutation public setDataLoading: any;

  @Mutation public setGameLoading: any;

  private app: any;

  private data: any = [];

  // bg music
  private bgMusic: any;

  // 当前选中的下标
  private currentActiveIndex: any;

  // 当前选中的id
  private currentActiveId: any;

  // 第几次点击
  private clickTimes: number = 0;

  // 当前得分
  private scoreNumber: number = 0;

  // 当前错误次数
  private errNumber: number = 0;

  // 倒计时 3分钟
  private countdownTime: number = 2 * 60 * 1000;

  // 当前时间
  private currentCountDownTime: number = 2 * 60 * 1000;

  // 定时器
  private countdownTimer: any;

  // 连续做对题数
  private currencyRightNumber: number = 0;

  // 进度条设计稿宽度
  private progressWidth: number = 797;

  // gameStatistics
  private gameStatisticsId: any;

  private residueDegree: any;

  // 是否记录排行
  private playModel: any = 1;

  // 参数
  private para: any = {
    accuracyNum: '', // 正确数量
    courseId: window.LS.get('basicData').courseId, // 课程编号
    errorNum: '', // 错误数量
    firstLoad: 0, // 0-第一次加载，1-非第一次加载
    gameId: 2, // 游戏编号
    gameStatisticsId: '', // 游戏记录编号
    playModel: 1, // 0-不记录成绩，1-记录成绩,默认为1
    userId: window.LS.get('basicData').userId, // 学生编号
    sendScore: 1, // 不发送成绩
  };

  private canClick: boolean = true;

  // wordContainer
  private wordContainer: any;

  private created() {
    // this.setDataLoading(false);
  }

  private beforeDestroy() {
    // this.countTime.setPaused(true);
    createjs.Tween.removeAllTweens();
    this.bgMusic.stop();
    this.setDataLoading(true);
    this.setGameLoading(true);
  }

  private mounted() {
    const that: any = this;
    this.app = new createjs.Stage('root');
    // Howl
    const mousePointOver: any = new Howl({
      src: [require('@/assets/images/game/linker/sound1.mp3')],
    });
    this.bgMusic = new Howl({
      src: [require('@/assets/images/game/linker/mapBGM.mp3')],
      loop: true,
      // autoplay: true,
    });
    (window as any).bgMusic = this.bgMusic;
    const soundscore: any = new Howl({
      src: [require('@/assets/images/game/linker/score.mp3')],
    });
    const sounderror: any = new Howl({
      src: [require('@/assets/images/game/linker/error.mp3')],
    });
    class CurrentGame extends Base {
      constructor(options: any) {
        super(options);
        // this.config = config
      }

      // 倒计时
      private countTime: any = createjs.Tween.get(that.progressshape);

      // 倒计时
      private countTimeGo: any = createjs.Tween.get(that.wordContainer);

      // 得分box
      private scoreContainer = new createjs.Container();

      // 失败box
      private errContainer = new createjs.Container();

      // 倒计时
      private progressshape: any;

      // 正确答案
      private correctAnswer: any;

      private going: any = false;

      protected initStage(): void {
        // sprites 引入图片
        const bg = new createjs.Bitmap(App.loader.getResult('bg'));
        const back = new createjs.Bitmap(App.loader.getResult('back'));
        const title = new createjs.Bitmap(App.loader.getResult('title'));
        const btn = new createjs.Bitmap(App.loader.getResult('btn'));
        // game
        const plantl = new createjs.Bitmap(App.loader.getResult('plantl'));
        const plantr = new createjs.Bitmap(App.loader.getResult('plantr'));
        const poster = new createjs.Bitmap(App.loader.getResult('poster'));
        const messagebg = new createjs.Bitmap(App.loader.getResult('message'));
        const goback = new createjs.Bitmap(App.loader.getResult('goback'));
        // level
        const score = new createjs.Bitmap(App.loader.getResult('score'));
        const wrong = new createjs.Bitmap(App.loader.getResult('wrong'));
        const sound = new createjs.Bitmap(App.loader.getResult('sound'));
        const nosound = new createjs.Bitmap(App.loader.getResult('nosound'));
        const logo = new createjs.Bitmap(App.loader.getResult('logo'));
        const right = new createjs.Bitmap(App.loader.getResult('right'));
        // 木板
        const show = new createjs.Bitmap(App.loader.getResult('show'));
        const mask = new createjs.Bitmap(App.loader.getResult('mask'));
        // 打中效果
        const bob = new createjs.Bitmap(App.loader.getResult('bob'));
        const errdialog = new createjs.Bitmap(
          App.loader.getResult('errdialog'),
        );
        const errclose = new createjs.Bitmap(App.loader.getResult('close'));

        // 得分记录 失败次数记录
        // let scoreContainer = new createjs.Container();
        // let wrongContainer = new createjs.Container();
        const readyContainer = new createjs.Container();
        const gameContainer = new createjs.Container();
        // 初始化得分
        const scoreTimes = this.score(that.scoreNumber);
        // 初始化错误次数
        const errTimesMax = this.err(that.errNumber);
        this.errContainer.addChild(errTimesMax);
        this.scoreContainer.addChild(scoreTimes);
        this.scoreContainer.setTransform(1181, 54, 1, 1, 0, 0, 0, 0, 0);
        score.setTransform(1181, 54, 1, 1, 0, 0, 0, 0, 0);
        this.errContainer.setTransform(1476, 53, 1, 1, 0, 0, 0, 0, 0);
        wrong.setTransform(1476, 53, 1, 1, 0, 0, 0, 0, 0);
        // progress box
        const progressContainer = new createjs.Container();
        const progressbox = new createjs.Bitmap(
          App.loader.getResult('progressbox'),
        );
        const progress = new createjs.Bitmap(App.loader.getResult('progress'));
        this.progressshape = new createjs.Shape();
        this.progressshape.graphics.drawRect(
          0,
          0,
          progress.getBounds().width,
          progress.getBounds().height,
        );
        progressContainer.addChild(progressbox, progress, this.progressshape);
        progressContainer.setTransform(252, 70, 1, 1, 0, 0, 0, 0, 0);
        progressbox.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
        progress.setTransform(14, 15, 1, 1, 0, 0, 0, 0, 0);
        this.progressshape.setTransform(14, 15, 1, 1, 0, 0, 0, 0, 0);
        // mask
        progress.mask = this.progressshape;
        // progress animation

        bg.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
        title.setTransform(159, 349, 1, 1, 0, 0, 0, 0, 0);
        btn.setTransform(
          463 + btn.getBounds().width / 2,
          654 + btn.getBounds().height / 2,
          1,
          1,
          0,
          0,
          0,
          btn.getBounds().width / 2,
          btn.getBounds().height / 2,
        );
        readyContainer.addChild(bg, title, btn);
        // back.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
        // game
        poster.setTransform(1584, 753, 1, 1, 0, 0, 0, 0, 0);
        plantl.setTransform(0, 368, 1, 1, 0, 0, 0, 0, 0);
        plantr.setTransform(1661, 938, 1, 1, 0, 0, 0, 0, 0);
        goback.setTransform(47, 53, 1, 1, 0, 0, 0, 0, 0);
        sound.setTransform(1768, 53, 1, 1, 0, 0, 0, 0, 0);
        nosound.setTransform(1768, 53, 1, 1, 0, 0, 0, 0, 0);
        logo.setTransform(845, 982, 1, 1, 0, 0, 0, 0, 0);
        bob.setTransform(220, -25, 1, 1, 0, 0, 0, 0, 0);
        errdialog.setTransform(612, 304, 1, 1, 0, 0, 0, 0, 0);
        errclose.setTransform(1222, 321, 1, 1, 0, 0, 0, 0, 0);
        // mask.setTransform(170, 441, 1, 1, 0, 0, 0, 0, 0);

        // let jia = new createjs.Bitmap(App.loader.getResult("jia"));
        // let jian = new createjs.Bitmap(App.loader.getResult("jian"));
        const correctBox = new createjs.Container();
        const correctImgBox = new createjs.Container();
        gameContainer.addChild(back, plantl, correctBox);
        // init word
        that.wordContainer = new createjs.Container();

        that.wordContainer.setTransform(110, 196, 1, 1, 0, 0, 0, 0, 0);

        const initCountDownTime = (seconds: number) => {
          clearInterval(that.countdownTimer);
          this.countTime.setPaused(true);
          //     // speed+= 400;
          this.progressshape.x = -(797 / that.countdownTime) * seconds + 15;
          this.countTime = createjs.Tween.get(this.progressshape)
            .to(
              { x: -that.progressWidth + 15 },
              that.countdownTime,
              createjs.Ease.easeOut,
            )
            .call(() => {
              // 弹出结束
              showMask();
              // createjs.Tween.removeAllTweens();
              createjs.Tween.removeTweens(that.wordContainer);
              // 清除定时器
              // clearInterval(that.countdownTimer)
            });
          that.countdownTimer = setInterval(() => {
            that.currentCountDownTime -= 1000;
            // console.log(that.currentCountDownTime);
          }, 1000);
        };
        const initWord = () => {
          // wordItem.removeChild(bob);
          // createjs.Tween.removeAllTweens();
          // init width x y
          // alert(2)
          let offsetX = 0;
          let offsetY = 0;
          const ruleX = 359 + 60;
          const ruleY = 234 + 62;
          that.fastPsoterGame(that.para).then((res: any) => {
            // 气球飘动
            if (this.going) {
              that.wordContainer.removeAllChildren();
              that.wordContainer.setTransform(110, 196, 1, 1, 0, 0, 0, 0, 0);
              this.countTimeGo = createjs.Tween.get(that.wordContainer)
                .to({ x: 1920 }, 30000, createjs.Ease.easeOut)
                .call(() => {
                  // 123
                  // 错误计数

                  // 错误计数
                  this.countTimeGo.setPaused(true);
                  sounderror.play();

                  that.errNumber++;
                  addScore(2);
                  this.errContainer.removeAllChildren();
                  const errTimesMax = this.err(that.errNumber);
                  this.errContainer.addChild(errTimesMax);

                  if (that.errNumber == 5) {
                    this.countTimeGo.setPaused(true);
                    that.fastPsoterGameErr().then((res: any) => {
                      if (res.data.code == 0) {
                        that.residueDegree = res.data.data.residueDegree;
                        // 弹出结束
                        showMask();
                      }
                    });
                    return false;
                  }

                  const errmask = this.initMask();
                  errmask.on('mouseover', () => {});
                  const correctAnswerDefinition = new createjs.Text(
                    correctAnswer.wordDefinition,
                    '24px bold impact',
                    '#8C6B57',
                  );
                  const correctAnswerText = new createjs.Text(
                    correctAnswer.word,
                    '30px bold impact',
                    '#FF7300',
                  );
                  correctAnswerText.set({
                    x: 1003,
                    lineWidth: 193,
                    y: 455,
                  });
                  correctAnswerDefinition.set({
                    x: 1003,
                    lineWidth: 193,
                    y: 542,
                  });
                  // 正确答案文字
                  // correctAnswerText.setTransform(1003, 455, 1, 0, 0, 0, 0, 0);
                  gameContainer.addChild(
                    errmask,
                    errdialog,
                    errclose,
                    correctImgBox,
                    correctAnswerText,
                    correctAnswerDefinition,
                  );
                  errclose.cursor = 'pointer';
                  errclose.removeAllEventListeners();
                  errclose.on('click', () => {
                    // wordItem.removeChild(bob)
                    // this.countTime.setPaused(true);
                    gameContainer.removeChild(
                      errmask,
                      errdialog,
                      errclose,
                      correctImgBox,
                      correctAnswerText,
                      correctAnswerDefinition,
                    );
                    // alert(that.para.firstLoad)
                    that.para.firstLoad = 1;
                    that.para.gameStatisticsId = that.gameStatisticsId;
                    initWord();
                  });
                  // initWord();
                });
            }
            checkedContainer.removeAllChildren();
            that.canClick = true;
            // 第一次加载完成
            that.setDataLoading(false);
            that.data = res.data.data && res.data.data.scwl;
            that.gameStatisticsId = res.data.data.gameStatistics.gameStatisticsId;
            that.residueDegree = res.data.data.residueDegree;
            // 随机一个正确的答案
            let correctAnswer = that.data[Math.round(Math.random() * 3)];
            this.correctAnswer = correctAnswer;

            correctImgBox.addChild(mask);
            correctBox.addChild(show);
            correctBox.setTransform(993, 870, 1, 1, 0, 0, 0, 0, 0);
            correctImgBox.setTransform(720, 407, 1, 1, 0, 0, 0, 0, 0);
            // let correctImg = new createjs.Bitmap('http://word.ebopo.cn/vte/images/pic/' + correctAnswer.pic);
            // correctImg.x = 70;
            // correctImg.y = 5;
            const image = new Image();
            image.src = correctAnswer.pic;
            image.onload = function () {
              const correctImg = new createjs.Bitmap(image);
              correctImg.scaleX = 250 / image.width;
              correctImg.scaleY = 270 / image.height;
              // correctImg.x = 66;
              // correctImg.y = 32;
              correctImgBox.addChild(correctImg);
            };
            const correctText = new createjs.Text(
              correctAnswer.word,
              '46px bold impact',
              '#FFFFFF',
            );

            correctText.set({
              textAlign: 'center',
              textBaseline: 'middle',
              x: 430 / 2,
              lineWidth: 464,
              y: 210 / 2,
            });
            correctBox.addChild(correctText);
            // -------------------
            that.data.map((item: any, index: number) => {
              const wordItem = new createjs.Container();

              wordItem.cursor = 'pointer';
              // messagebg
              const messagebg1 = new createjs.Bitmap(
                App.loader.getResult('box1'),
              );
              const messagebg2 = new createjs.Bitmap(
                App.loader.getResult('box2'),
              );
              const messagebg3 = new createjs.Bitmap(
                App.loader.getResult('box3'),
              );
              const messagebg4 = new createjs.Bitmap(
                App.loader.getResult('box4'),
              );
              // shape.graphics.beginFill("#ffffff").drawRect(0, 0, 270, 147);
              let text: any;
              let textHover: any;

              text = new createjs.Text(
                item.wordDefinition,
                '36px bold impact',
                '#FFFFFF',
              );
              textHover = new createjs.Text(
                item.wordDefinition,
                '56px bold impact',
                '#FF6800',
              );
              textHover.shadow = new createjs.Shadow('#000000', 5, 5, 5); // 创建文字阴影
              text.set({
                textAlign: 'center',
                textBaseline: 'middle',
                x: 600 / 2,
                lineWidth: 340,
                y: 100 / 2,
              });

              if (index == 0) {
                wordItem.addChild(messagebg1);
              } else if (index == 1) {
                wordItem.addChild(messagebg2);
              } else if (index == 2) {
                wordItem.addChild(messagebg3);
              } else if (index == 3) {
                wordItem.addChild(messagebg4);
              }
              wordItem.addChild(text);
              wordItem.x = offsetX;
              wordItem.y = offsetY;
              that.wordContainer.addChild(wordItem);

              offsetX += 150;
              offsetY += 174;
              // 鼠标事件不穿透到子元素
              wordItem.mouseChildren = false;
              wordItem.on('click', (e: any) => {
                if (!that.canClick) {
                  return false;
                }
                wordItem.addChild(bob);
                that.canClick = false;
                // return false;
                if (correctAnswer.ucwId == item.ucwId) {
                  // 正确
                  createjs.Tween.removeTweens(that.wordContainer);
                  soundscore.play();
                  that.scoreNumber++;
                  addScore(1);
                  setTimeout(() => {
                    this.scoreContainer.removeAllChildren();
                    const scoreTimes = this.score(that.scoreNumber);
                    this.scoreContainer.addChild(scoreTimes);
                    that.wordContainer.removeAllChildren();
                    // firstLoad:1 ; sendScore:1-不发送；gameStatisID
                    that.para.firstLoad = 1;
                    that.para.gameStatisticsId = that.gameStatisticsId;
                    correctBox.removeChild(correctText);
                    initWord();
                    that.wordContainer.setTransform(
                      110,
                      196,
                      1,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                    );
                    this.countTimeGo = createjs.Tween.get(that.wordContainer)
                      .to({ x: 1920 }, 30000, createjs.Ease.easeOut)
                      .call(() => {
                        // 123
                        // 错误计数
                        sounderror.play();
                        that.errNumber++;
                        addScore(2);
                        setTimeout(() => {
                          this.errContainer.removeAllChildren();
                          const errTimesMax = this.err(that.errNumber);
                          this.errContainer.addChild(errTimesMax);
                          wordItem.removeChild(bob);
                          that.para.firstLoad = 1;
                          that.para.gameStatisticsId = that.gameStatisticsId;
                          correctBox.removeChild(correctText);
                          initWord();
                        }, 1000);

                        if (that.errNumber == 5) {
                          that.fastPsoterGameErr().then((res: any) => {
                            if (res.data.code == 0) {
                              that.residueDegree = res.data.data.residueDegree;
                              // 弹出结束
                              showMask();
                            }
                          });
                        }
                      });
                  }, 1000);
                } else {
                  createjs.Tween.removeTweens(that.wordContainer);
                  sounderror.play();
                  that.errNumber++;
                  // 错误数量立刻变更
                  this.errContainer.removeAllChildren();
                  const errTimesMax = this.err(that.errNumber);
                  this.errContainer.addChild(errTimesMax);
                  addScore(2);
                  if (that.errNumber == 5) {
                    this.countTime.setPaused(true);
                    that.fastPsoterGameErr().then((res: any) => {
                      if (res.data.code == 0) {
                        that.residueDegree = res.data.data.residueDegree;
                        // 弹出结束
                        showMask();
                      } // 122
                    });
                    return false;
                  }
                  // 错误
                  // 错误计数
                  const errmask = this.initMask();
                  errmask.on('mouseover', () => {});
                  const correctAnswerDefinition = new createjs.Text(
                    correctAnswer.wordDefinition,
                    '24px bold impact',
                    '#8C6B57',
                  );
                  const correctAnswerText = new createjs.Text(
                    correctAnswer.word,
                    '30px bold impact',
                    '#FF7300',
                  );
                  correctAnswerText.set({
                    x: 1003,
                    lineWidth: 193,
                    y: 455,
                  });
                  correctAnswerDefinition.set({
                    x: 1003,
                    lineWidth: 100,
                    y: 542,
                  });
                  // 正确答案文字
                  // correctAnswerText.setTransform(1003, 455, 1, 0, 0, 0, 0, 0);
                  gameContainer.addChild(
                    errmask,
                    errdialog,
                    errclose,
                    correctImgBox,
                    correctAnswerText,
                    correctAnswerDefinition,
                  );
                  errclose.cursor = 'pointer';
                  errclose.removeAllEventListeners();
                  errclose.on('click', () => {
                    wordItem.removeChild(bob);
                    // this.countTime.setPaused(true);
                    gameContainer.removeChild(
                      errmask,
                      errdialog,
                      errclose,
                      correctImgBox,
                      correctAnswerText,
                      correctAnswerDefinition,
                    );
                    that.para.firstLoad = 1;
                    that.para.gameStatisticsId = that.gameStatisticsId;
                    correctBox.removeChild(correctText);
                    initWord();
                  });
                }
              });
              // map
            });
          });

          // 选中的container
          let checkedContainer = new createjs.Container();
          checkedContainer.x = 850;
          checkedContainer.y = 264;
          // 测试用
          // gameContainer.addChild(scorebg, five);
          gameContainer.addChild(checkedContainer);
        };
        // mask
        const showMask = () => {
          clearInterval(that.countdownTimer);
          this.countTime.setPaused(true);
          that.currencyRightNumber = 0;
          that.currentCountDownTime = that.countdownTime;
          const maskContainer = new createjs.Container();

          const mask = this.initMask();
          const dialog = new createjs.Bitmap(App.loader.getResult('dialog'));
          maskContainer.setTransform(676, 319, 1, 1, 0, 0, 0, 0, 0);
          const onemore = new createjs.Bitmap(App.loader.getResult('onemore'));
          const onemorea = new createjs.Bitmap(
            App.loader.getResult('onemorea'),
          );
          const selected = new createjs.Bitmap(
            require('@/assets/images/game/linker/selected.png'),
          );
          const unselected = new createjs.Bitmap(
            require('@/assets/images/game/linker/uns.png'),
          );
          onemore.setTransform(89, 310, 1, 1, 0, 0, 0, 0, 0);
          onemorea.setTransform(89, 310, 1, 1, 0, 0, 0, 0, 0);
          // 默认选中状态

          if (that.para.playModel == 1) {
            unselected.alpha = 0;
            selected.alpha = 1;
          } else {
            unselected.alpha = 1;
            selected.alpha = 0;
          }
          selected.cursor = 'pointer';
          unselected.cursor = 'pointer';
          // 123
          const text = new createjs.Text(
            `今天还可以玩${that.residueDegree}次`,
            '20px PingFangSC-Regular',
            '#FFC800',
          );
          selected.on('click', (e: any) => {
            // 不展示 不计入排行
            that.para.playModel = 0;
            selected.alpha = 0;
            // text.alpha = 0;
            unselected.alpha = 1;
            // console.log(that.para);
          });
          unselected.on('click', (e: any) => {
            // 展示 计入排行
            that.para.playModel = 1;
            selected.alpha = 1;
            // text.alpha = 1;
            unselected.alpha = 0;
            // console.log(that.para);
          });
          onemore.cursor = 'pointer';
          onemorea.cursor = 'pointer';
          onemore.removeAllEventListeners();
          onemore.on('mousedown', (e: any) => {
            // 再来一局

            // maskContainer.rem oveAllChildren();
            maskContainer.removeChild(onemore);

            // this.progressshape.x = 0;

            // int progress
          });
          onemore.on('pressup', (e: any) => {
            // 再来一局
            if (that.residueDegree == 0) {
              window.toFinish.postMessage('toFinish');
              // that.$router.push({
              //   path: "/vocabulary/afterschoolexpand?type=through"
              //   // query: {
              //   //     id: 4,
              //   //     // gameId: scope.row.game.id
              //   // }
              // });
              return false;
            }
            initCountDownTime(0);
            // 重置
            that.wordContainer.removeAllChildren();
            this.going = true;
            //
            // onemore.alpha = 0;
            // 如果有游戏次数 重新开始
            // 失败次数重置
            that.errNumber = 0;
            const errTimesMax = this.err(that.errNumber);
            this.errContainer.addChild(errTimesMax);
            // 得分重置
            that.scoreNumber = 0;
            const scoreTimes = this.score(that.scoreNumber);
            this.scoreContainer.addChild(scoreTimes);
            that.app.stage.removeChild(mask, maskContainer);
            that.app.stage.update();
            that.para.firstLoad = 0;
            that.para.sendScore = 1;
            that.para.gameStatisticsId = '';
            initWord();
          });
          // one more 不玩了

          const goover = new createjs.Bitmap(App.loader.getResult('goover'));
          const goovera = new createjs.Bitmap(App.loader.getResult('goovera'));
          goover.setTransform(314, 310, 1, 1, 0, 0, 0, 0, 0);
          goovera.setTransform(314, 310, 1, 1, 0, 0, 0, 0, 0);
          selected.setTransform(122, 198, 1, 1, 0, 0, 0, 0, 0);
          unselected.setTransform(122, 198, 1, 1, 0, 0, 0, 0, 0);
          text.setTransform(215, 249, 1, 1, 0, 0, 0, 0, 0);
          goover.cursor = 'pointer';
          goovera.cursor = 'pointer';
          goover.on('mousedown', (e: any) => {
            //
            goover.alpha = 0;
          });
          goover.on('pressup', (e: any) => {
            window.toFinish.postMessage('toFinish');
            // that.$router.push({
            //   path: "/vocabulary/afterschoolexpand?type=through"
            //   // query: {
            //   //     id: 4,
            //   //     // gameId: scope.row.game.id
            //   // }
            // });
          });
          maskContainer.addChild(
            dialog,
            goovera,
            goover,
            onemorea,
            onemore,
            selected,
            unselected,
            text,
          );
          that.app.stage.addChild(mask, maskContainer);
          // 防止穿透的另一种方法 覆盖层事件覆盖
          mask.on('mouseover', () => {});
        };
        // 时间提示
        const addTimeAn = (type: number) => {
          const scorebg = new createjs.Bitmap(App.loader.getResult('scorebg'));
          const five = new createjs.Bitmap(App.loader.getResult('five'));
          const fifteen = new createjs.Bitmap(App.loader.getResult('fifteen'));

          five.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
          fifteen.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
          scorebg.setTransform(
            769 + scorebg.getBounds().width / 2,
            393 + scorebg.getBounds().height / 2,
            1,
            1,
            0,
            0,
            0,
            scorebg.getBounds().width / 2,
            scorebg.getBounds().height / 2,
          );
          if (type == 5) {
            gameContainer.addChild(scorebg, five);
          } else if (type == 15) {
            gameContainer.addChild(scorebg, fifteen);
          }
          createjs.Tween.get(scorebg, { loop: true })
            .to({ rotation: 180 }, 1000, createjs.Ease.easeOut)
            .call(() => {
              createjs.Tween.get(fifteen)
                .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                .call(() => {
                  gameContainer.removeChild(fifteen);
                });
              createjs.Tween.get(five)
                .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                .call(() => {
                  gameContainer.removeChild(five);
                });
              createjs.Tween.get(scorebg)
                .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                .call(() => {
                  gameContainer.removeChild(scorebg);
                });
            });
        };
        // const addLetter = () => {

        // }
        // addScore
        const addScore = (type: number) => {
          const addbox = new createjs.Container();
          const addtext = new createjs.Text(
            '+ 1',
            'bold 100px impact',
            '#44D7B6',
          );
          const minusbox = new createjs.Container();
          const minustext = new createjs.Text(
            '- 1',
            'bold 100px impact',
            '#F669AB',
          );
          addbox.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
          addbox.addChild(addtext);
          minusbox.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
          minusbox.addChild(minustext);
          if (type == 1) {
            gameContainer.addChild(addbox);
            createjs.Tween.get(addbox)
              .to({ x: 1181, y: 54, alpha: 0.3 }, 1000, createjs.Ease.easeOut)
              .call(() => {
                gameContainer.removeChild(addbox);
              });
          } else if (type == 2) {
            gameContainer.addChild(minusbox);
            createjs.Tween.get(minusbox)
              .to({ x: 1476, y: 54, alpha: 0.3 }, 1000, createjs.Ease.easeOut)
              .call(() => {
                gameContainer.removeChild(minusbox);
              });
          }
        };

        gameContainer.addChild(
          that.wordContainer,
          goback,
          progressContainer,
          sound,
          nosound,
          wrong,
          score,
          this.errContainer,
          this.scoreContainer,
        );
        // 禁止播放按钮
        nosound.alpha = 0;
        gameContainer.alpha = 0;
        // readyContainer.alpha = 0;

        that.app.stage.addChild(gameContainer, readyContainer);
        // 音量事件
        sound.on('click', (e: any) => {
          that.bgMusic.stop();
          // 更换图片
          nosound.alpha = 1;
        });
        nosound.cursor = 'pointer';
        nosound.on('click', (e: any) => {
          that.bgMusic.play();
          // 更换图片
          nosound.alpha = 0;
        });
        // start
        btn.cursor = 'pointer';
        btn.on('click', (e: any) => {
          // 调接口
          this.going = true;
          initWord();
          readyContainer.alpha = 0;
          gameContainer.alpha = 1;
          initCountDownTime(0);
          nosound.alpha = 0;
          // 播放背景音乐
          that.bgMusic.play();
          // this.countTimeGo  = createjs.Tween.get(that.wordContainer)
          //     .to({x: 1920}, 30000, createjs.Ease.easeOut)
          //     .call(()=>{ // 123
          //          // 错误计数
          //         // 错误计数
          //         this.going = true;
          //         this.countTimeGo.setPaused(true);
          //         sounderror.play();
          //         that.errNumber++;

          //         addScore(2);
          //         this.errContainer.removeAllChildren();
          //         let errTimesMax = this.err(that.errNumber);
          //         this.errContainer.addChild(errTimesMax);
          //         let errmask = this.initMask();
          //             errmask.on('mouseover', function() {

          //             })
          //             let correctAnswerDefinition = new createjs.Text(this.correctAnswer.wordDefinition, "24px bold impact", "#8C6B57");
          //             let correctAnswerText =  new createjs.Text(this.correctAnswer.word, "30px bold impact", "#FF7300");
          //             correctAnswerText.set({
          //                 x: 1003,
          //                 lineWidth: 193,
          //                 y: 455
          //             })
          //             correctAnswerDefinition.set({
          //                 x: 1003,
          //                 lineWidth: 193,
          //                 y: 542
          //             })
          //             // 正确答案文字
          //             // correctAnswerText.setTransform(1003, 455, 1, 0, 0, 0, 0, 0);
          //             gameContainer.addChild(errmask, errdialog, errclose, correctImgBox, correctAnswerText, correctAnswerDefinition)
          //             errclose.cursor='pointer';
          //             errclose.removeAllEventListeners();
          //             errclose.on('click', () => {
          //                 this.countTime.setPaused(true);
          //                 gameContainer.removeChild(errmask, errdialog, errclose, correctImgBox, correctAnswerText, correctAnswerDefinition)
          //                 that.para.firstLoad = 1;
          //                 that.para.gameStatisticsId = that.gameStatisticsId;
          //                 initWord();
          //                 that.wordContainer.setTransform(110, 196, 1, 1, 0, 0, 0, 0, 0);
          //                 this.countTimeGo  = createjs.Tween.get(that.wordContainer)
          //                 .to({x: 1920}, 30000, createjs.Ease.easeOut)
          //                 .call(()=>{ // 123
          //                         // 错误计数
          //                         sounderror.play();
          //                         that.errNumber++;
          //                         addScore(2);
          //                         this.errContainer.removeAllChildren();
          //                         let errTimesMax = this.err(that.errNumber);
          //                         this.errContainer.addChild(errTimesMax);

          //                         if (that.errNumber == 5) {
          //                             that.fastPsoterGameErr().then((res: any) => {
          //                                 if (res.data.code == 0) {
          //                                     that.residueDegree = res.data.data.residueDegree;
          //                                     // 弹出结束
          //                                     showMask();
          //                                 }
          //                             })
          //                         }
          //                 });
          //             });
          // });
        });
        // back
        goback.cursor = 'pointer';
        goback.on('click', (e: any) => {
          // mask = this.init_mask();
          that.bgMusic.stop();
          // readyContainer.alpha = 1;
          // gameContainer.alpha = 0;
          window.toFinish.postMessage('toFinish');
          // that.$router.push({
          //   path: '/vocabulary/afterschoolexpand?type=through',
          //   // query: {
          //   //     id: 4,
          //   //     // gameId: scope.row.game.id
          //   // }
          // });
        });
        // sound
        sound.cursor = 'pointer';

        createjs.Tween.get(btn, { loop: true })
          .to({ scaleX: 1.2, scaleY: 1.2 }, 400, createjs.Ease.linear)
          .to({ scaleX: 0.9, scaleY: 0.9 }, 400, createjs.Ease.linear);

        this.makeResponsive(
          true,
          'both',
          false,
          1,
          {
            canvas: 'root',
          },
          that.app,
        );
        this.startAnimation(that.app.stage);
      }

      protected score(value: number) {
        this.scoreContainer.removeAllChildren();
        const scoreTimes = new createjs.Text(value, '35px impact', '#44D7B6');
        scoreTimes.setTransform(150, 30, 1, 1, 0, 0, 0, 0, 0);
        return scoreTimes;
      }

      protected err(value: number) {
        this.errContainer.removeAllChildren();
        const errTimesMax = new createjs.Text(
          `${value} / 5`,
          '35px impact',
          '#66461F',
        );
        errTimesMax.setTransform(130, 33, 1, 1, 0, 0, 0, 0, 0);
        return errTimesMax;
      }
    }

    // 实例化
    const game = new CurrentGame(config);
  }

  // ajax
  private async fastPsoterGame(para: any) {
    return await Game.fastPsoterGame(para);
  }

  // 改为时间结束调接口
  private async fastPsoterGameErr() {
    const para = {
      courseId: window.LS.get('basicData').courseId,
      firstLoad: 1,
      gameId: 2,
      accuracyNum: this.scoreNumber,
      errorNum: this.errNumber,
      playModel: 1, // 是否记录排行榜
      userId: window.LS.get('basicData').userId,
      gameStatisticsId: this.gameStatisticsId,
      sendScore: 0, // 结束游戏的时候 发送成绩
    };
    return await Game.fastPsoterGame(para);
  }
}
